import { Button, Col, Modal, Row } from "antd";
import * as React from "react";
import { observer } from "mobx-react";

import { AutocompleteView } from "../../../core/ui/autocomplete/autocomplete.view";
import { DateView } from "../../../core/ui/date.view";
import { TextView } from "../../../core/ui/text.view";
import { RegionEditorController } from "../../general/regions/parts/region-editor.controller";

interface PaxTravelDocumentProps {
	travelDocument: {
		documentType: string;
		documentNumber: string;
		issuedDate: Date;
		expirationDate: Date;
		expeditionPlace: string;
		nationality: string;
		countryOfResidence: number;
	};
	mode: ControlMode;
	title: string;
	nationalityQuery: DropdownRequest<AutocompleteSummary>;
	documentTypeQuery: DropdownRequest<AutocompleteSummary>;
	setBusy: (boolean) => void;
}

interface PaxTravelDocumentState {
	showModal: boolean;
	documentType?: string;
	documentNumber?: string;
	issuedDate?: Date;
	expirationDate?: Date;
	expeditionPlace?: string;
	nationality?: string;
	countryOfResidence?: number;
}

@observer
export class PaxTravelDocument extends React.Component<PaxTravelDocumentProps, PaxTravelDocumentState> {
	public state: PaxTravelDocumentState = {
		showModal: false,
	};

	public render() {
		const {
			showModal,
			documentNumber,
			documentType,
			issuedDate,
			expeditionPlace,
			expirationDate,
			nationality,
			countryOfResidence,
		} = this.state;		
		const { mode, travelDocument, title, setBusy } = this.props;

		const text = `${travelDocument.documentType || ""}${travelDocument.documentType != null ? ": " : ""}${travelDocument.documentNumber || ""}`;
		return (
			<React.Fragment>
				<Modal
					visible={showModal}
					onCancel={this.closeDialog}
					title={`Travel document for ${title}`}
					footer={[<Button type="primary" key='ok' onClick={this.okDialog}>OK</Button>]}
				>
					<Row>
						<Col span={24}>
							<AutocompleteView
								required={true}
								label="Document type"
								disabled={mode == 'display'}
								model={documentType}
								onChanged={this.onChange("documentType", "value")}
								request={this.props.documentTypeQuery}
								onGetErrorMessage={() => Promise.resolve(documentType != "" ? [] : [{ property: "documentType", text: documentType }])}
							/>
						</Col>
						<Col span={24}>
							<TextView
								required
								mode={mode}
								onGetErrorMessage={() => Promise.resolve(documentNumber != "" ? [] : [{ property: "documentNumber", text: documentNumber }])}
								label="Document number"
								value={documentNumber}
								onChanged={this.onChange("documentNumber")}
							/>
						</Col>
						<Col span={24}>
							<DateView
								mode={mode}
								onGetErrorMessage={() => Promise.resolve(issuedDate != null ? [] : [{ property: "issuedDate", text: "" }])}
								label="Issued date"
								value={issuedDate}
								format="date"
								onChanged={this.onChange("issuedDate")}
								dateUsage="utc"
							/>
						</Col>
						<Col span={24}>
							<DateView
								mode={mode}
								onGetErrorMessage={() => Promise.resolve(expirationDate != null ? [] : [{ property: "expirationDate", text: "" }])}
								label="Expiration date"
								value={expirationDate}
								format="date"
								onChanged={this.onChange("expirationDate")}
								dateUsage="utc"
							/>
						</Col>
						<Col span={24}>
							<TextView
								mode={mode}
								onGetErrorMessage={() => Promise.resolve(expeditionPlace != "" ? [] : [{ property: "expeditionPlace", text: expeditionPlace }])}
								label="Expedition place"
								value={expeditionPlace}
								onChanged={this.onChange("expeditionPlace")}
							/>
						</Col>
						<Col span={24}>
							<AutocompleteView
								label="Nationality"
								disabled={mode == 'display'}
								model={nationality}
								onChanged={this.onChange("nationality", "value")}
								request={this.props.nationalityQuery}
							/>
						</Col>
						<Col span={24}>
							<RegionEditorController
								label="Country of residence"
								mode={mode}
								onChanged={this.onChange("countryOfResidence", "id")}
								value={countryOfResidence}
								setBusy={setBusy}
							/>
						</Col>
					</Row>
				</Modal>
				<Button onClick={this.openDialog}>
					{text === "" ? "---" : text}
				</Button>
			</React.Fragment>
		);
	}

	private onChange = (prop: string, innerProp?: string) => (value) => {
		const state: any = {};
		state[prop] = innerProp ? (value ? value[innerProp] : undefined) : value;
		this.setState(state);
	}

	private openDialog = () => {
		this.setState({
			showModal: true,
			...this.props.travelDocument,
		});
	}

	private closeDialog = () => {
		this.setState({
			showModal: false,
			documentNumber: undefined,
			documentType: undefined,
			issuedDate: undefined,
			expeditionPlace: undefined,
			expirationDate: undefined,
			nationality: undefined,
			countryOfResidence: undefined,
		});
	}

	private okDialog = () => {
		const { travelDocument } = this.props;
		const { documentNumber, documentType, issuedDate, expeditionPlace, expirationDate, nationality, countryOfResidence } = this.state;
		
		travelDocument.documentNumber = documentNumber;
		travelDocument.documentType = documentType;
		travelDocument.issuedDate = issuedDate;
		travelDocument.expeditionPlace = expeditionPlace;
		travelDocument.expirationDate = expirationDate;
		travelDocument.nationality = nationality;
		travelDocument.countryOfResidence = countryOfResidence;
		this.setState({
			showModal: false,
			documentNumber: undefined,
			documentType: undefined,
			issuedDate: undefined,
			expeditionPlace: undefined,
			expirationDate: undefined,
			nationality: undefined,
			countryOfResidence: undefined,
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-paxs/pax-travel-document.tsx